import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Instagram, Youtube, Music2, Twitter } from "lucide-react";
import { BRAND, NAV_LINKS, STREAMING } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API}/newsletter`, { email, source: "footer" });
      toast.success("You're in.");
      setEmail("");
    } catch {
      toast.error("Try again later.");
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-black overflow-hidden">
      <img
        src={BRAND.logo}
        alt=""
        className="pointer-events-none absolute -right-20 -bottom-32 w-[480px] opacity-[0.04]"
        aria-hidden
      />
      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="logo" className="w-11 h-11 rounded-full border border-white/10" />
            <span className="font-display text-xl">it&apos;s Malie</span>
          </div>
          <p className="mt-5 font-display italic text-white/70 text-lg max-w-sm">{BRAND.tagline}</p>
          <p className="mt-2 text-sm text-white/45 max-w-sm">Sound that moves culture. Music rooted in purpose.</p>
        </div>

        <div className="lg:col-span-3">
          <p className="overline mb-5">Navigate</p>
          <ul className="grid grid-cols-2 gap-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-white/65 hover:text-[color:var(--gold)] transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="overline mb-5">Stay in the loop</p>
          <form onSubmit={submit} data-testid="footer-newsletter" className="flex items-center gap-2 glass rounded-full px-4 py-1.5">
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="email@yours.com"
              required
              data-testid="footer-email"
              className="flex-1 bg-transparent outline-none text-sm py-2"
            />
            <button data-testid="footer-subscribe" type="submit" className="rounded-full px-4 py-2 text-xs uppercase tracking-[0.18em] bg-[color:var(--gold)] text-black font-semibold hover:opacity-90">Subscribe</button>
          </form>

          <div className="flex items-center gap-3 mt-6">
            <a href={STREAMING.spotify} target="_blank" rel="noopener noreferrer" data-testid="footer-spotify" aria-label="Spotify" className="w-10 h-10 grid place-items-center rounded-full border border-white/10 hover:border-[color:var(--gold)] hover:text-[color:var(--gold)] transition-colors"><Music2 size={14} /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 grid place-items-center rounded-full border border-white/10 hover:border-[color:var(--gold)] hover:text-[color:var(--gold)] transition-colors"><Instagram size={14} /></a>
            <a href={STREAMING.youtubeMusic} target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" aria-label="YouTube" className="w-10 h-10 grid place-items-center rounded-full border border-white/10 hover:border-[color:var(--gold)] hover:text-[color:var(--gold)] transition-colors"><Youtube size={14} /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" data-testid="footer-twitter" aria-label="Twitter" className="w-10 h-10 grid place-items-center rounded-full border border-white/10 hover:border-[color:var(--gold)] hover:text-[color:var(--gold)] transition-colors"><Twitter size={14} /></a>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} it&apos;s Malie. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" data-testid="footer-privacy" className="hover:text-white">Privacy</a>
            <a href="#" data-testid="footer-terms" className="hover:text-white">Terms</a>
            <a href="#booking" data-testid="footer-press" className="hover:text-white">Press Kit</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
